import GeneralLottie from './GeneralLottie';

export default GeneralLottie;
